var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cw-list-cell',{staticClass:"has-border-bottom",attrs:{"title":_vm.project.name,"subtitle":_vm.getSubtitleText(),"disclosureDetail":`${(_vm.project.currentDispatchSets && _vm.project.currentDispatchSets.length) ||
      ''}`,"showDisclosureIndicator":_vm.showDisclosureIndicator,"showSelectedIndicator":_vm.showSelectedIndicator,"leftIconProps":_vm.iconProps},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }